import { forwardRef } from 'react';

const Input = forwardRef(function Input({
  label, name, type = 'text', placeholder, value, onChange,
  error, required = false, hint, prefix, className = '',
  ...rest
}, ref) {
  return (
    <div className={`space-y-1 ${className}`}>
      {label && (
        <label htmlFor={name} className="block text-sm font-medium text-gray-700">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      <div className="relative">
        {prefix && (
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
            <span className="text-gray-500 text-sm">{prefix}</span>
          </div>
        )}
        <input
          id={name}
          name={name}
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          ref={ref}
          className={`
            block w-full rounded-lg border shadow-sm text-sm
            px-3 py-2.5 ${prefix ? 'pl-8' : ''}
            ${error
              ? 'border-red-300 focus:ring-red-500 focus:border-red-500'
              : 'border-gray-300 focus:ring-brand-500 focus:border-brand-500'
            }
            focus:outline-none focus:ring-2
            disabled:bg-gray-50 disabled:text-gray-500
          `}
          {...rest}
        />
      </div>
      {hint  && !error && <p className="text-xs text-gray-500">{hint}</p>}
      {error && <p className="text-xs text-red-600">{error}</p>}
    </div>
  );
});

export default Input;
